import { useContext, createContext } from 'react';

import { configurationContextDefaultValues } from '../constants';
import type { AppConfiguration } from '../types';

export const configurationContext = createContext<AppConfiguration>(configurationContextDefaultValues);

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
